import { render, staticRenderFns } from "./ProvincialOfficer.vue?vue&type=template&id=180fc7b6&"
import script from "./ProvincialOfficer.vue?vue&type=script&lang=js&"
export * from "./ProvincialOfficer.vue?vue&type=script&lang=js&"
import style0 from "./ProvincialOfficer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports